export default __webpack_public_path__ + "static/media/cost-estimation-template.d3d389f6.xlsx";